import { createContext, useContext } from 'react'

import { defaultLanguage, defaultPartnerKey, defaultServingSize } from 'constants'
import { getShopButtonElement, getQSFromPartner, getUTMFromPartner, getLanguageFromHost, getValidButtonScale } from 'helper'

function getDataFlag(value) {
  // empty data attributes are falsy: https://stackoverflow.com/a/23752239/7615084
  return value !== undefined
}

/// Reads the parameters set on the <div> using the data attributes.
export function getParams(ele) {
  const element = ele || getShopButtonElement()
  const utmSource = getUTMFromPartner('utm_source')
  const utmCampaign = getUTMFromPartner('utm_campaign')
  const utmMedium = getUTMFromPartner('utm_medium')
  const zipCodeFromQS = getQSFromPartner('zip_code')
  return {
    bgColor: element.dataset.bgColor,
    buttonCopy: element.dataset.buttonText,
    headerCopy: element.dataset.headerText,
    strictProduct: getDataFlag(element.dataset.strictProduct),
    textColor: element.dataset.textColor,
    headerColor: element.dataset.headerColor,
    disableHeader : getDataFlag(element.dataset.disableHeader),
    disablePoweredBy: getDataFlag(element.dataset.disablePoweredBy),
    grocers: element.dataset.retailers,
    disabledGrocers: element.dataset.disabledRetailers,
    lang: getLanguageFromHost() || defaultLanguage,
    externalId: element.dataset.externalId || undefined,
    buttonStyle: element.dataset.styleButton,
    enableCircularAd: getDataFlag(element.dataset.circularAd),
    enableSponsoredProductAd: getDataFlag(element.dataset.sponsoredProductAd),
    validateLiquor: getDataFlag(element.dataset.enabledLiquor),
    partner: element.dataset.partnerKey || defaultPartnerKey,
    liquorMessage: element.dataset.liquorMessage,
    liquorUrl: element.dataset.liquorUrl,
    disableViewAll: getDataFlag(element.dataset.disableViewAll),
    // private feature, only support this data attribute one year after release
    disablePoweredByInPopup: getDataFlag(element.dataset.disablePoweredByPopup),
    buttonScale: getValidButtonScale(element.dataset.buttonScale),
    utmSource: utmSource,
    utmCampaign: utmCampaign,
    utmMedium: utmMedium,
    highlightAiAdapter: getDataFlag(element.dataset.highlightAiAdapter),
    zipCode: zipCodeFromQS,
    tbrecipeId: parseInt(element.dataset.recipeId) || undefined,
    servingSize: parseInt(element.dataset.serving) || defaultServingSize,
    referrerName: element.dataset.referrerName || undefined,
    theme: element.dataset.themeId || undefined,
    enableAvailabilityAware: getDataFlag(element.dataset.availabilityAware),
    shoppablelinkId: parseInt(element.dataset.shoppablelinkId) || undefined,
  }
}

export const ConfigurationContext = createContext(getParams())

export const V2ConfigurationContext = createContext({})

export function useConfiguration() {
  return useContext(ConfigurationContext)
}
